import ZkSystemAnnouncement from './src/main'
ZkSystemAnnouncement.install = function (Vue) {
  Vue.component(ZkSystemAnnouncement.name, ZkSystemAnnouncement)
}
export default ZkSystemAnnouncement



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/systemAnnouncement/index.js